import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Badge } from "reactstrap";

class DeliveryService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [
        {
          id: 1,
          name: "Standard Delivery",
          description: "Cost-effective delivery service with flexible scheduling options",
          timeframe: "24-48 hours",
          price: "Starting at R250",
          features: ["Real-time tracking", "Insurance up to R10,000", "SMS notifications"]
        },
        {
          id: 2,
          name: "Express Delivery",
          description: "Priority delivery service for time-sensitive shipments",
          timeframe: "Same day - 24 hours",
          price: "Starting at R450",
          features: ["Priority handling", "Insurance up to R20,000", "SMS and email notifications", "Dedicated support"]
        },
        {
          id: 3,
          name: "Scheduled Delivery",
          description: "Plan your deliveries in advance with guaranteed time slots",
          timeframe: "Book up to 30 days in advance",
          price: "Starting at R350",
          features: ["Guaranteed time slots", "Insurance up to R15,000", "Full notification suite", "Recurring delivery options"]
        }
      ]
    };
  }

  componentDidMount() {
    document.title = "Delivery Services | QikTruck";
  }

  render() {
    return (
      <React.Fragment>
        
        <section className="section mt-5 pt-4">
          <Container>
            <Row className="mb-5">
              <Col lg={12} className="text-center">
                <h2 className="mb-3">Delivery Services</h2>
                <p className="lead">
                  Fast, reliable, and cost-effective delivery solutions for your business
                </p>
              </Col>
            </Row>
            
            <Row>
              {this.state.services.map((service) => (
                <Col lg={4} key={service.id} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <CardHeader className="bg-primary text-white">
                      <h4 className="mb-0">{service.name}</h4>
                    </CardHeader>
                    <CardBody>
                      <p>{service.description}</p>
                      <div className="mb-3">
                        <Badge color="info" className="me-2">{service.timeframe}</Badge>
                        <Badge color="success">{service.price}</Badge>
                      </div>
                      <h6>Features:</h6>
                      <ul>
                        {service.features.map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                      <div className="text-center mt-4">
                        <button className="btn btn-primary">Book Now</button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Row className="mt-5">
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">How It Works</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={3} className="text-center mb-4 mb-md-0">
                        <div className="rounded-circle bg-light p-3 d-inline-block mb-3">
                          <h2 className="mb-0">1</h2>
                        </div>
                        <h5>Book Your Delivery</h5>
                        <p className="small">Choose your service type and provide pickup/delivery details</p>
                      </Col>
                      <Col md={3} className="text-center mb-4 mb-md-0">
                        <div className="rounded-circle bg-light p-3 d-inline-block mb-3">
                          <h2 className="mb-0">2</h2>
                        </div>
                        <h5>Package Collection</h5>
                        <p className="small">Our driver will arrive at the pickup location in the specified time window</p>
                      </Col>
                      <Col md={3} className="text-center mb-4 mb-md-0">
                        <div className="rounded-circle bg-light p-3 d-inline-block mb-3">
                          <h2 className="mb-0">3</h2>
                        </div>
                        <h5>Track in Real-time</h5>
                        <p className="small">Follow your package's journey from pickup to delivery</p>
                      </Col>
                      <Col md={3} className="text-center">
                        <div className="rounded-circle bg-light p-3 d-inline-block mb-3">
                          <h2 className="mb-0">4</h2>
                        </div>
                        <h5>Delivery Confirmation</h5>
                        <p className="small">Receive proof of delivery once your package is safely delivered</p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default DeliveryService; 